"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tr = exports.Thead = exports.Th = exports.Td = exports.Tbody = exports.Table = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["className", "children", "theme"],
  _excluded2 = ["children", "label", "theme"];
var defaultTheme = {
  theme: {
    media_query: "@media \n            only screen and (max-width: 760px),\n            (min-device-width: 768px) and (max-device-width: 1024px)"
  }
};

//
// Table
//
var Table = exports.Table = (0, _styledComponents["default"])(function (_ref) {
  var className = _ref.className,
    children = _ref.children,
    theme = _ref.theme,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({
    className: "responsive-table ".concat(className)
  }, props), children);
}).withConfig({
  displayName: "responsiveTable__Table"
})(["width:100%;", "{display:block;}"], function (props) {
  return props.theme.media_query;
});
Table.defaultProps = defaultTheme;

//
// Thead
//
var Thead = exports.Thead = _styledComponents["default"].thead.withConfig({
  displayName: "responsiveTable__Thead"
})(["", "{display:block;& tr{position:absolute;top:-9999px;left:-9999px;}}"], function (props) {
  return props.theme.media_query;
});
Thead.defaultProps = defaultTheme;

//
// Tbody
//
var Tbody = exports.Tbody = _styledComponents["default"].tbody.withConfig({
  displayName: "responsiveTable__Tbody"
})(["", "{display:block;}"], function (props) {
  return props.theme.media_query;
});
Tbody.defaultProps = defaultTheme;

//
// Th
//
var Th = exports.Th = _styledComponents["default"].th.withConfig({
  displayName: "responsiveTable__Th"
})(["background:transparent;height:40px;", "{height:auto;text-align:left;display:block;}"], function (props) {
  return props.theme.media_query;
});
Th.defaultProps = defaultTheme;

//
// Tr
//
var Tr = exports.Tr = _styledComponents["default"].tr.withConfig({
  displayName: "responsiveTable__Tr"
})(["", "{display:block;}"], function (props) {
  return props.theme.media_query;
});
Tr.defaultProps = defaultTheme;
var ResponsiveTableLabel = _styledComponents["default"].span.withConfig({
  displayName: "responsiveTable__ResponsiveTableLabel"
})(["display:none;"]);

//
// Td
//
var Td = exports.Td = (0, _styledComponents["default"])(function (_ref2) {
  var children = _ref2.children,
    label = _ref2.label,
    theme = _ref2.theme,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("td", props, /*#__PURE__*/_react["default"].createElement(ResponsiveTableLabel, {
    className: "responsive-table-label"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, label)), children);
}).withConfig({
  displayName: "responsiveTable__Td"
})(["", "{display:block;position:relative;&:last-child{margin-bottom:0;}", "{all:unset;display:block;}}"], function (props) {
  return props.theme.media_query;
}, ResponsiveTableLabel);
Td.propTypes = {
  label: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
Td.defaultProps = defaultTheme;